const React = require('react');
const { ESHOP } = require('../utils/constants/sections');
const { useSupermarketShop } = require('../pages/home/hooks/useSupermarketShop');

function withMarketplaceInfo(WrappedComponent) {
  const MarketplaceInfo = (props) => {
    const { isSupermarketShop } = useSupermarketShop();

    return (
      <WrappedComponent
        {...props}
        layoutTheme={ESHOP}
        isSuper={isSupermarketShop}
      />
    );
  };
  return MarketplaceInfo;
}

module.exports = withMarketplaceInfo;
